import { type FunctionComponent } from 'react'
import { format, roundToNearestMinutes } from 'date-fns'
import { type InboxThreadEventEventableContactReplyType } from '@/state/entities/inbox/inbox.types'
import { TimeFormats } from '@/common/datepicker/utilities/formats'
import { ThreadPopover } from './common'
import { MessageRow } from './message-row'

function ThreadContactReplyBox({
  event,
}: {
  event: InboxThreadEventEventableContactReplyType
}): ReturnType<FunctionComponent> {
  const { thread_contact } = event
  const name = thread_contact.name ?? thread_contact.email ?? 'Contact'

  return (
    <MessageRow
      direction="incoming"
      name={name}
      email={thread_contact.email ?? ''}
      meta="Contact reply"
      time={format(
        roundToNearestMinutes(event.created_at, { nearestTo: 10 }),
        TimeFormats.FourHourApple
      )}
      info={<ThreadPopover event={event} />}
    >
      <p className="text-sm leading-relaxed whitespace-pre-line break-words">
        {event.description}
      </p>
    </MessageRow>
  )
}

export default ThreadContactReplyBox
